// SheEarnsRewardingCooking.jsx
import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faStar,
  faBookOpen,
  faGift,
  faShoppingBag,
  faUser,
  faList,
  faHome,
  faChartBar,
  faCalendar,
  faGlobe,
} from '@fortawesome/free-solid-svg-icons';

// -----------------------------------------------------
// Simple translation dictionary (can later be replaced with i18n)
// -----------------------------------------------------
const translations = {
  en: {
    appTitle: "SheEarns: Rewarding Cooking",
    tabDashboard: "Dashboard",
    tabMenu: "My Menu",
    tabOrders: "Orders",
    tabTiffin: "Tiffin Plans",
    tabRewards: "Rewards",
    tabLearning: "Learning",
    tabCustomer: "Order Food",
    tabAdmin: "Admin",
    tabProfile: "Profile",
    thisMonthEarnings: "This Month's Earnings",
    ordersCompleted: "Orders Completed",
    topSelling: "Top Selling",
    totalPoints: "Total Points",
    yourRewardPoints: "Your Reward Points",
    kitchenBadges: "Kitchen Badges",
    watch: "Watch",
    cart: "Cart",
    items: "items",
    proceedCheckout: "Proceed to Checkout (Demo)",
    subscriptionPlans: "Subscription Plans",
    popularTiffinPlans: "Popular Tiffin Plans",
    activeHomeChefs: "Active Home Chefs",
    totalRevenue: "Total Revenue",
    totalOrders: "Total Orders",
    cityCoverage: "Cities Covered",
    adminOverview: "Platform Overview",
    language: "Language",
  },
  hi: {
    appTitle: "SheEarns: रिवार्डिंग कुकिंग",
    tabDashboard: "डैशबोर्ड",
    tabMenu: "मेरा मेनू",
    tabOrders: "ऑर्डर",
    tabTiffin: "टिफिन प्लान",
    tabRewards: "रिवॉर्ड्स",
    tabLearning: "सीखें",
    tabCustomer: "फूड ऑर्डर",
    tabAdmin: "एडमिन",
    tabProfile: "प्रोफ़ाइल",
    thisMonthEarnings: "इस महीने की कमाई",
    ordersCompleted: "पूरे हुए ऑर्डर",
    topSelling: "सबसे ज्यादा बिकने वाला",
    totalPoints: "कुल पॉइंट्स",
    yourRewardPoints: "आपके रिवॉर्ड पॉइंट्स",
    kitchenBadges: "किचन बैज",
    watch: "देखें",
    cart: "कार्ट",
    items: "आइटम",
    proceedCheckout: "चेकआउट (डेमो)",
    subscriptionPlans: "सब्सक्रिप्शन प्लान",
    popularTiffinPlans: "लोकप्रिय टिफिन प्लान",
    activeHomeChefs: "सक्रिय होम शेफ",
    totalRevenue: "कुल राजस्व",
    totalOrders: "कुल ऑर्डर",
    cityCoverage: "कवर्ड शहर",
    adminOverview: "प्लेटफ़ॉर्म ओवरव्यू",
    language: "भाषा",
  },
  mr: {
    appTitle: "SheEarns: रिवॉर्डिंग कुकिंग",
    tabDashboard: "डॅशबोर्ड",
    tabMenu: "माझे मेनू",
    tabOrders: "ऑर्डर्स",
    tabTiffin: "टिफिन योजना",
    tabRewards: "रिवॉर्ड्स",
    tabLearning: "शिका",
    tabCustomer: "फूड ऑर्डर",
    tabAdmin: "ॲडमिन",
    tabProfile: "प्रोफाईल",
    thisMonthEarnings: "या महिन्याची कमाई",
    ordersCompleted: "पूर्ण झालेले ऑर्डर्स",
    topSelling: "टॉप सेलिंग",
    totalPoints: "टोटल पॉइंट्स",
    yourRewardPoints: "तुमचे रिवॉर्ड पॉइंट्स",
    kitchenBadges: "किचन बॅजेस",
    watch: "पाहा",
    cart: "कार्ट",
    items: "आयटम",
    proceedCheckout: "चेकआऊट (डेमो)",
    subscriptionPlans: "सबस्क्रिप्शन योजना",
    popularTiffinPlans: "लोकप्रिय टिफिन योजना",
    activeHomeChefs: "सक्रिय होम शेफ",
    totalRevenue: "एकूण उत्पन्न",
    totalOrders: "एकूण ऑर्डर्स",
    cityCoverage: "शहरे",
    adminOverview: "प्लॅटफॉर्म ओव्हरव्ह्यू",
    language: "भाषा",
  },
  ta: {
    appTitle: "SheEarns: Rewarding Cooking",
    tabDashboard: "டாஷ்போர்டு",
    tabMenu: "என் மெனு",
    tabOrders: "ஆர்டர்கள்",
    tabTiffin: "டிஃபின் திட்டம்",
    tabRewards: "விருதுகள்",
    tabLearning: "கற்க",
    tabCustomer: "உணவு ஆர்டர்",
    tabAdmin: "அட்மின்",
    tabProfile: "சுயவிவரம்",
    thisMonthEarnings: "இந்த மாத வருமானம்",
    ordersCompleted: "நிறைவு பெற்ற ஆர்டர்கள்",
    topSelling: "அதிகம் விற்பனை",
    totalPoints: "மொத்த பாயின்ட்கள்",
    yourRewardPoints: "உங்கள் ரிவார்டு பாயின்ட்கள்",
    kitchenBadges: "அடுக்கு அறை பேட்ஜ்கள்",
    watch: "பார்க்க",
    cart: "கார்ட்",
    items: "பொருட்கள்",
    proceedCheckout: "செக்அவுட் (டெமோ)",
    subscriptionPlans: "சப்ஸ்கிரிப்ஷன் திட்டங்கள்",
    popularTiffinPlans: "பிரபல டிஃபின் திட்டங்கள்",
    activeHomeChefs: "செயலில் ஹோம் செஃப்ஸ்",
    totalRevenue: "மொத்த வருவாய்",
    totalOrders: "மொத்த ஆர்டர்கள்",
    cityCoverage: "நகரங்கள்",
    adminOverview: "பிளாட்ஃபார்ம் ஓவர்வியூ",
    language: "மொழி",
  },
};

const SheEarnsRewardingCooking = () => {
  const [lang, setLang] = useState("en");
  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;

  const [activeTab, setActiveTab] = useState("dashboard");

  // ---------------- Dummy Data ----------------
  const menuItems = [
    {
      id: 1,
      name: "Homemade Veg Thali",
      price: 120,
      desc: "Chapati, dal, rice, seasonal sabzi, salad",
      img: "https://via.placeholder.com/400x250",
      veg: true,
    },
    {
      id: 2,
      name: "Masala Poha",
      price: 40,
      desc: "Light & flavorful breakfast with peanuts",
      img: "https://via.placeholder.com/400x250",
      veg: true,
    },
    {
      id: 3,
      name: "Besan Ladoo Box (12 pcs)",
      price: 180,
      desc: "Festive special made with pure ghee",
      img: "https://via.placeholder.com/400x250",
      veg: true,
    },
  ];

  const tiffinPlans = [
    {
      id: "plan1",
      name: "Office Tiffin – 5 Days",
      price: 2200,
      desc: "Lunch for Monday to Friday, includes dal, sabzi, 3 chapatis, rice.",
      type: "Veg",
    },
    {
      id: "plan2",
      name: "Student Tiffin – 30 Days",
      price: 3800,
      desc: "Light dinner for hostellers, homely taste, less oil & masala.",
      type: "Veg",
    },
    {
      id: "plan3",
      name: "Working Couple – 30 Days",
      price: 5200,
      desc: "Lunch + Dinner combo, perfect for busy couples.",
      type: "Veg",
    },
  ];

  const orders = [
    { id: 1, item: "Veg Thali", qty: 2, total: 240, status: "Pending" },
    { id: 2, item: "Besan Ladoo", qty: 1, total: 180, status: "Delivered" },
    { id: 3, item: "Masala Poha", qty: 3, total: 120, status: "Delivered" },
  ];

  const learning = [
    { title: "How to price homemade food", duration: "5 min" },
    { title: "Basics of FSSAI for Home Kitchens", duration: "3 min" },
    { title: "Food packaging & labelling tips", duration: "4 min" },
    { title: "How to talk to customers politely", duration: "3 min" },
  ];

  // Rewards gamification: missions + dynamic points
  const [missions, setMissions] = useState([
    { id: "mission1", title: "Add your first 5 menu items", basePoints: 40, completed: true },
    { id: "mission2", title: "Complete 10 successful orders", basePoints: 50, completed: false },
    { id: "mission3", title: "Update daily menu for 7 days", basePoints: 30, completed: false },
    { id: "mission4", title: "Get 5 five-star reviews", basePoints: 60, completed: false },
  ]);

  const lifetimePoints = 120; // fixed from past activity
  const dynamicPoints = missions
    .filter((m) => m.completed)
    .reduce((sum, m) => sum + m.basePoints, 0);

  const totalPoints = lifetimePoints + dynamicPoints;

  // Simple cart for customer ordering
  const [cart, setCart] = useState([]);

  const addToCart = (item, type = "menu") => {
    setCart((prev) => {
      const existing = prev.find(
        (p) => p.id === item.id && p.type === type
      );
      if (existing) {
        return prev.map((p) =>
          p.id === item.id && p.type === type
            ? { ...p, qty: p.qty + 1 }
            : p
        );
      }
      return [...prev, { ...item, qty: 1, type }];
    });
  };

  const cartSummary = cart.reduce(
    (acc, item) => {
      acc.qty += item.qty;
      acc.total += item.price * item.qty;
      return acc;
    },
    { qty: 0, total: 0 }
  );

 const tabs = [
  { id: "dashboard", labelKey: "tabDashboard", icon: <FontAwesomeIcon icon={faUser} /> },
  { id: "menu", labelKey: "tabMenu", icon: <FontAwesomeIcon icon={faList} /> },
  { id: "orders", labelKey: "tabOrders", icon: <FontAwesomeIcon icon={faShoppingBag} /> },
  { id: "tiffin", labelKey: "tabTiffin", icon: <FontAwesomeIcon icon={faCalendar} /> },
  { id: "rewards", labelKey: "tabRewards", icon: <FontAwesomeIcon icon={faGift} /> },
  { id: "learning", labelKey: "tabLearning", icon: <FontAwesomeIcon icon={faBookOpen} /> },
  { id: "customer", labelKey: "tabCustomer", icon: <FontAwesomeIcon icon={faHome} /> },
  { id: "admin", labelKey: "tabAdmin", icon: <FontAwesomeIcon icon={faChartBar} /> },
  { id: "profile", labelKey: "tabProfile", icon: <FontAwesomeIcon icon={faStar} /> },
];

  // ---------------- Sub-Components ----------------

  const Dashboard = () => (
    <div className="space-y-4 p-4">
      <div className="grid grid-cols-2 gap-3">
        <div className="bg-pink-900/30 p-4 rounded-xl shadow-lg">
          <p className="text-pink-200 text-sm">{t("thisMonthEarnings")}</p>
          <h2 className="text-pink-300 text-2xl font-bold mt-2">₹ 12,430</h2>
        </div>
        <div className="bg-pink-900/30 p-4 rounded-xl shadow-lg">
          <p className="text-pink-200 text-sm">{t("ordersCompleted")}</p>
          <h2 className="text-pink-300 text-2xl font-bold mt-2">57</h2>
        </div>
      </div>

      <div className="bg-pink-900/20 p-4 rounded-xl">
        <h3 className="text-pink-300 font-semibold text-lg mb-2">
          {t("topSelling")}
        </h3>
        <ul className="text-pink-200 space-y-1 text-sm">
          <li>• Veg Thali – 180 orders</li>
          <li>• Rava Idli Plate – 120 orders</li>
          <li>• Monthly Tiffin – 60 subscriptions</li>
        </ul>
      </div>
    </div>
  );

  const Menu = () => (
    <div className="p-4 space-y-4">
      {menuItems.map((m) => (
        <div
          key={m.id}
          className="bg-pink-900/20 p-4 rounded-xl flex gap-4 shadow-md"
        >
          <img
            src={m.img}
            alt={m.name}
            className="w-24 h-20 object-cover rounded-md"
          />
          <div className="flex-1">
            <h3 className="text-pink-300 font-semibold text-sm lg:text-base">
              {m.name}
            </h3>
            <p className="text-pink-200 text-xs lg:text-sm">{m.desc}</p>
            <p className="text-pink-300 mt-1 font-bold text-sm">
              ₹ {m.price} • {m.veg ? "Veg" : "Non-Veg"}
            </p>
          </div>
        </div>
      ))}
    </div>
  );

  const Orders = () => (
    <div className="p-4 space-y-4">
      {orders.map((o) => (
        <div
          key={o.id}
          className="bg-pink-900/20 p-4 rounded-xl flex justify-between items-center shadow-md"
        >
          <div>
            <h4 className="text-pink-300 font-semibold text-sm lg:text-base">
              {o.item}
            </h4>
            <p className="text-pink-200 text-xs lg:text-sm">
              Qty: {o.qty} • Total: ₹{o.total}
            </p>
          </div>
          <span
            className={`px-3 py-1 rounded-full text-xs lg:text-sm ${
              o.status === "Pending"
                ? "bg-yellow-400 text-black"
                : "bg-green-400 text-black"
            }`}
          >
            {o.status}
          </span>
        </div>
      ))}
    </div>
  );

  const TiffinPlans = () => (
    <div className="p-4 space-y-4">
      <h2 className="text-pink-300 text-lg font-bold mb-2">
        {t("popularTiffinPlans")}
      </h2>
      {tiffinPlans.map((plan) => (
        <div
          key={plan.id}
          className="bg-pink-900/20 p-4 rounded-xl flex flex-col gap-2 shadow-md"
        >
          <div>
            <h3 className="text-pink-300 font-semibold text-sm lg:text-base">
              {plan.name}
            </h3>
            <p className="text-pink-200 text-xs lg:text-sm">{plan.desc}</p>
            <p className="text-pink-300 font-bold mt-1 text-sm">
              ₹ {plan.price} / {plan.type}
            </p>
          </div>
        </div>
      ))}
    </div>
  );

  const Rewards = () => (
    <div className="p-4 space-y-4">
      <h2 className="text-pink-300 text-xl font-bold">
        {t("yourRewardPoints")}
      </h2>

      <div className="bg-pink-900/20 p-4 rounded-xl">
        <h3 className="text-pink-300 font-semibold text-lg">
          {t("totalPoints")}
        </h3>
        <p className="text-pink-200 text-3xl font-bold">{totalPoints}</p>
        <p className="text-pink-200 text-xs mt-1">
          (Lifetime: {lifetimePoints} + Missions: {dynamicPoints})
        </p>
      </div>

      {missions.map((m) => (
        <div
          key={m.id}
          className="bg-pink-900/20 p-4 rounded-xl flex justify-between items-center shadow-md"
        >
          <div>
            <p className="text-pink-300 text-sm lg:text-base">{m.title}</p>
            <p className="text-pink-200 text-xs">+{m.basePoints} pts</p>
          </div>
          <button
            onClick={() =>
              setMissions((prev) =>
                prev.map((mission) =>
                  mission.id === m.id
                    ? { ...mission, completed: !mission.completed }
                    : mission
                )
              )
            }
            className={`w-40 px-3 py-1 rounded-lg text-xs lg:text-sm ${
              m.completed
                ? "bg-green-400 text-black"
                : "bg-pink-700 text-black"
            }`}
          >
            {m.completed ? "Completed" : "Mark Done"}
          </button>
        </div>
      ))}
    </div>
  );

  const Learning = () => (
    <div className="p-4 space-y-4">
      {learning.map((l, idx) => (
        <div
          key={idx}
          className="bg-pink-900/20 p-4 rounded-xl flex justify-between items-center shadow-md"
        >
          <div>
            <h4 className="text-pink-300 font-semibold text-sm lg:text-base">
              {l.title}
            </h4>
            <p className="text-pink-200 text-xs lg:text-sm">{l.duration}</p>
          </div>
          <button className="w-40 bg-pink-700 text-black px-3 py-1 rounded-lg text-xs lg:text-sm">
            {t("watch")}
          </button>
        </div>
      ))}
    </div>
  );

  const CustomerOrdering = () => (
    <div className="p-4 space-y-4">
      {/* Cart Summary */}
      <div className="bg-pink-900/30 p-4 rounded-xl flex justify-between items-center">
        <div>
          <h3 className="text-pink-300 font-semibold text-sm lg:text-base">
            {t("cart")} ({cartSummary.qty} {t("items")})
          </h3>
          <p className="text-pink-200 text-xs lg:text-sm">
            ₹ {cartSummary.total}
          </p>
        </div>
        <button
          className="w-40 bg-pink-700 text-black px-3 py-2 rounded-lg text-xs lg:text-sm"
          onClick={() => {
            // frontend-only demo behaviour
            alert("Demo checkout – backend integration pending.");
          }}
          disabled={cartSummary.qty === 0}
        >
          {t("proceedCheckout")}
        </button>
      </div>

      {/* Customer Visible Menu */}
      <h2 className="text-pink-300 font-bold text-lg mb-2">
        Daily Home Menu
      </h2>
      {menuItems.map((m) => (
        <div
          key={m.id}
          className="bg-pink-900/20 p-4 rounded-xl flex gap-3 items-center shadow-md"
        >
          <img
            src={m.img}
            alt={m.name}
            className="w-16 h-16 object-cover rounded-md"
          />
          <div className="flex-1">
            <h3 className="text-pink-300 font-semibold text-sm lg:text-base">
              {m.name}
            </h3>
            <p className="text-pink-200 text-xs lg:text-sm">{m.desc}</p>
            <p className="text-pink-300 font-bold text-sm mt-1">
              ₹ {m.price}
            </p>
          </div>
          <button
            className="w-40 bg-pink-700 text-black px-3 py-2 rounded-lg text-xs lg:text-sm"
            onClick={() => addToCart(m, "menu")}
          >
            Add
          </button>
        </div>
      ))}

      {/* Tiffin Subscriptions for Customers */}
      <h2 className="text-pink-300 font-bold text-lg mt-4 mb-2">
        {t("subscriptionPlans")}
      </h2>
      {tiffinPlans.map((plan) => (
        <div
          key={plan.id}
          className="bg-pink-900/20 p-4 rounded-xl flex gap-2 items-center shadow-md"
        >
          <div className="flex-1">
            <h3 className="text-pink-300 font-semibold text-sm lg:text-base">
              {plan.name}
            </h3>
            <p className="text-pink-200 text-xs lg:text-sm">
              {plan.desc}
            </p>
            <p className="text-pink-300 font-bold text-sm mt-1">
              ₹ {plan.price}
            </p>
          </div>
          <button
            className="w-40 bg-pink-700 text-black px-3 py-2 rounded-lg text-xs lg:text-sm"
            onClick={() => addToCart(plan, "tiffin")}
          >
            Subscribe
          </button>
        </div>
      ))}
    </div>
  );

  const AdminDashboard = () => (
    <div className="p-4 space-y-4">
      <h2 className="text-pink-300 text-xl font-bold mb-2 flex items-center gap-2">
        <FontAwesomeIcon icon={faChartBar} className="text-pink-400 mr-1" /> {t("adminOverview")}
      </h2>

      <div className="grid grid-cols-2 gap-3">
        <div className="bg-pink-900/30 p-4 rounded-xl shadow-lg">
          <p className="text-pink-200 text-xs lg:text-sm">
            {t("activeHomeChefs")}
          </p>
          <h2 className="text-pink-300 text-2xl font-bold mt-2">482</h2>
        </div>
        <div className="bg-pink-900/30 p-4 rounded-xl shadow-lg">
          <p className="text-pink-200 text-xs lg:text-sm">
            {t("totalRevenue")}
          </p>
          <h2 className="text-pink-300 text-2xl font-bold mt-2">₹ 18.2 L</h2>
        </div>
        <div className="bg-pink-900/30 p-4 rounded-xl shadow-lg">
          <p className="text-pink-200 text-xs lg:text-sm">
            {t("totalOrders")}
          </p>
          <h2 className="text-pink-300 text-2xl font-bold mt-2">9,324</h2>
        </div>
        <div className="bg-pink-900/30 p-4 rounded-xl shadow-lg">
          <p className="text-pink-200 text-xs lg:text-sm">
            {t("cityCoverage")}
          </p>
          <h2 className="text-pink-300 text-2xl font-bold mt-2">27</h2>
        </div>
      </div>

      <div className="bg-pink-900/20 p-4 rounded-xl text-pink-200 text-xs lg:text-sm space-y-1">
        <p>• Highest orders: Mumbai, Pune, Bengaluru</p>
        <p>• Most popular segment: Working Professionals Tiffin</p>
        <p>• Peak order time: 12:30 PM – 2:00 PM</p>
      </div>
    </div>
  );

  const Profile = () => (
    <div className="p-4 space-y-4">
      <div className="bg-pink-900/20 p-4 rounded-xl text-center shadow-md">
        <h2 className="text-pink-300 text-xl font-bold">
          Anita Sharma
        </h2>
        <p className="text-pink-200 text-xs lg:text-sm">
          Home Chef • Mumbai
        </p>
        <p className="text-pink-200 mt-2 text-sm">
          ⭐ 4.8 (250 ratings)
        </p>
      </div>

      <div className="bg-pink-900/20 p-4 rounded-xl">
        <h3 className="text-pink-300 text-lg font-semibold mb-2">
          {t("kitchenBadges")}
        </h3>
        <ul className="text-pink-200 space-y-1 text-sm">
          <li>• FSSAI-Ready</li>
          <li>• Hygienic Kitchen</li>
          <li>• On-time Delivery</li>
        </ul>
      </div>
    </div>
  );

  const languages = [
    { code: "en", label: "EN" },
    { code: "hi", label: "हिं" },
    { code: "mr", label: "मरा" },
    { code: "ta", label: "தமிழ்" },
  ];

  const [open, setOpen] = useState(false);

  const handleSelect = (code) => {
    setLang(code);
    setOpen(false);
  };

  // ---------------- Main Render ----------------
  return (
    <div className="bg-black text-pink-300">
      <div className="min-h-[85vh] bg-black text-pink-300">
      <header className="flex flex-row items-center justify-between px-4 py-2 bg-black border-b border-blue-400">
        <h1 className="text-lg lg:text-2xl font-bold">
          {t("appTitle")}
        </h1>

        {/* Language Selector */}
        <div className="relative inline-block text-xs lg:text-sm text-pink-300">
        <button
            onClick={() => setOpen(!open)}
            className="flex items-center gap-1 px-3 py-1 rounded-md border border-pink-700 bg-gray-900 hover:bg-gray-800"
        >
            <FontAwesomeIcon icon={faGlobe} className="text-pink-400" />
            <span className="hidden lg:inline">{t("language")}:</span>
            <span className="ml-1 font-semibold">
            {languages.find((l) => l.code === lang)?.label}
            </span>
            <span className="ml-1">▾</span>
        </button>

        {open && (
            <ul className="absolute mt-1 w-40 bg-gray-900 border border-pink-700 rounded-md shadow-lg z-50 px-2">
            {languages.map((l) => (
                <li key={l.code}>
                <button
                    onClick={() => handleSelect(l.code)}
                    className={`w-full flex-1 items-center text-center px-3 py-2 hover:bg-pink-700 hover:text-black rounded-md ${
                    lang === l.code ? "bg-pink-700 text-black" : "text-pink-300"
                    }`}
                >
                    {l.label}
                </button>
                </li>
            ))}
            </ul>
        )}
        </div>
      </header>

      {/* Tabs */}
      <div className="mt-2 grid grid-cols-3 lg:grid-cols-6 gap-2 justify-center place-items-center">
        {tabs.map((tItem) => (
          <button
            key={tItem.id}
            onClick={() => setActiveTab(tItem.id)}
            className={`w-40 flex flex-col  p-2 rounded-lg text-[10px] lg:text-xs leading-tight ${
              activeTab === tItem.id
                ? "bg-pink-800 text-black"
                : "bg-pink-900 text-pink-300 hover:bg-pink-800/40 hover:text-white"
            }`}
          >
            <span className="text-lg">{tItem.icon}</span>
            <span className="text-white text-sm lg:text-m text-center whitespace-normal break-words">
              {t(tItem.labelKey)}
            </span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div
        key={activeTab + lang}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.25 }}
      >
        {activeTab === "dashboard" && <Dashboard />}
        {activeTab === "menu" && <Menu />}
        {activeTab === "orders" && <Orders />}
        {activeTab === "tiffin" && <TiffinPlans />}
        {activeTab === "rewards" && <Rewards />}
        {activeTab === "learning" && <Learning />}
        {activeTab === "customer" && <CustomerOrdering />}
        {activeTab === "admin" && <AdminDashboard />}
        {activeTab === "profile" && <Profile />}
      </div>   
    </div>
    <footer className="bg-black border-t border-blue-800 text-blue-300 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-blue-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-blue-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-blue-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-blue-400">Contact</Link>
          </div>
        </div>
      </footer>   
    </div>
  );
};

export default SheEarnsRewardingCooking;
